import { useEntityChangeSubscr } from '@/common/entityChange/EntityChangeContext';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';

export const JobList = ({ jobId, chain }) => {
  const rsrc = useRsrc();
  const { navigateTo } = useNavState();
  const entityListRef = useRef();
  const initialized = useRef(false);

  // Additionally subscribe to Run to update lastRunStatus
  const { refreshTrigger: runRefreshTrigger } = useEntityChangeSubscr('skdr', 'RUN');

  const getContextMenuItems = (params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);
    const data = params.node.data;

    if (data.cat !== 'APPR' && data.status === 'ACTIVE') {
      contextMenus.push({
        name: 'Start',
        action: () => rsrc.start(data.id),
        icon: fas.faPlay,
        disabled: ['RUN', 'WAITING', 'QUEUED'].includes(data.lastRunStatus),
        role: 'JOB_SAVE',
      });
    }

    contextMenus.push({
      name: 'Latest Run Details',
      action: () => navigateTo('skdr/run', { mode: Mode.DETAIL, entityId: data.lastRunId }),
      icon: fas.faClockRotateLeft,
      disabled: !data.lastRunId,
    });

    if (data.lastRunStatus === 'RUN') {
      contextMenus.push({
        name: 'Record Failure',
        action: () => {
          rsrc.byId('skdr', 'RUN', data.lastRunId).then((run) => {
            let eventObj = {
              runId: run.id,
              jobId: run.jobId,
              code: 'FINISH_FAILURE',
              type: 'FINISH_FAILURE',
              msg: 'Finished job per user request',
            };

            rsrc.save('skdr', 'EVENT', eventObj);
          });
        },
        icon: fas.faExclamationTriangle,
      });
    }

    return contextMenus;
  };

  const clientSideRowData = useCallback(
    (setDataSource) => {
      const reqParam = { jobId };
      rsrc.data('skdr', 'JOB_DATA_PLUGIN', reqParam).then((res) => {
        const gridApi = entityListRef.current?.gridRef?.current?.gridApiRef?.current;

        if (!initialized.current || !gridApi) {
          setDataSource(res);
          initialized.current = true;
        } else {
          gridApi.applyTransaction({ update: res });
        }
      });
    },
    [jobId],
  );

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.query = 'JOB_FETCH';
  });

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.hide = true;

    if (chain) {
      const nameFieldDef = fieldToFieldDef.name;
      nameFieldDef.autoGrouping = true;
      nameFieldDef.precedence = -1000;

      fieldToFieldDef.verStartInstant.sort = null;
    }
  };

  return (
    <EntityList
      ref={entityListRef}
      module="skdr"
      entity="JOB"
      augFieldDefs={augFieldDefs}
      refreshTrigger={runRefreshTrigger}
      {...(chain ? { clientSideRowData } : { augRowsReq })}
      gridOptions={{
        getContextMenuItems,
        ...(chain && {
          treeData: true,
          getRowId: (params) => String(params.data?.path),
        }),
      }}
    />
  );
};
